<div class="notification-container">
  <!-- Bouton de notification avec badge -->
  <div style="position: relative; display: inline-block;">
    <button
      pButton
      type="button"
      icon="pi pi-bell"
      class="p-button-text p-button-rounded notification-button"
      (click)="op.toggle($event)"
      [title]="'Vous avez ' + unreadCount + ' notification(s) non lue(s)'"
    ></button>
    <span *ngIf="unreadCount > 0" class="custom-badge">{{ unreadCount }}</span>
  </div>

  <!-- Overlay Panel pour les notifications -->
  <p-overlayPanel #op [style]="{ width: '420px', maxHeight: '600px' }" [dismissable]="true">
    <ng-template pTemplate="content">
      <div class="notification-panel">
        <!-- En-tête -->
        <div class="notification-header">
          <h3 class="notification-title">
            <i class="pi pi-bell mr-2"></i>
            Notifications
            <span *ngIf="unreadCount > 0" class="unread-badge">{{ unreadCount }}</span>
          </h3>
          <div class="notification-actions">
            <button
              *ngIf="unreadCount > 0"
              pButton
              type="button"
              label="Tout marquer comme lu"
              class="p-button-text p-button-sm"
              (click)="markAllAsRead()"
            ></button>
            <button
              *ngIf="notifications.length > 0"
              pButton
              type="button"
              label="Tout effacer"
              class="p-button-text p-button-sm p-button-danger"
              (click)="clearAll()"
            ></button>
          </div>
        </div>

        <!-- Liste des notifications -->
        <div class="notification-list">
          <p-scrollPanel [style]="{ width: '100%', height: '450px' }">
            <div *ngIf="notifications.length === 0" class="no-notifications">
              <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc;"></i>
              <p>Aucune notification</p>
            </div>

            <div
              *ngFor="let notification of notifications"
              class="notification-item"
              [class.unread]="!notification.read"
              [class]="getSeverityClass(notification.severity)"
              (click)="markAsRead(notification)"
            >
              <div class="notification-icon">
                <i class="pi" [ngClass]="getSeverityIcon(notification.severity)"></i>
              </div>
              <div class="notification-content">
                <div class="notification-summary">
                  {{ notification.summary }}
                  <span *ngIf="!notification.read" class="unread-dot"></span>
                </div>
                <div class="notification-detail">{{ notification.detail }}</div>
                <div class="notification-time">{{ getTimeAgo(notification.timestamp) }}</div>
              </div>
              <div class="notification-delete">
                <button
                  pButton
                  type="button"
                  icon="pi pi-times"
                  class="p-button-text p-button-rounded p-button-sm"
                  (click)="deleteNotification(notification.id, $event)"
                  title="Supprimer"
                ></button>
              </div>
            </div>
          </p-scrollPanel>
        </div>
      </div>
    </ng-template>
  </p-overlayPanel>
</div>
